import ValueWithLabel from "./valueWithLabel";
export default ValueWithLabel;
